<template>
  <div class="tabulka" :class="TableWidth">
    <div class="tabulka__top">
      <div class="tabulka__top__nadpis">Sold products</div>
      <download-excel
        v-if="sourceData.length"
        class="tabulka__top__button"
        :data="sortedData"
        :fields="json_fields"
        worksheet="Sold Products"
        name="sold_products.xls"
        >Download .xls
      </download-excel>
    </div>

    <div class="tabulka__body">
      <table>
        <thead>
          <td>
            <span>Round</span>
            <SortButton
              row="turn"
              type="0"
              :currentSortDirection="currentSortDirection"
              :currentSortRow="currentSortRow"
              v-on:sortBy="sortRow"
            />
          </td>
          <td>
            <span>Product</span>
            <SortButton
              row="productName"
              type="a"
              :currentSortDirection="currentSortDirection"
              :currentSortRow="currentSortRow"
              v-on:sortBy="sortRow"
            />
          </td>
          <td>
            <span>Sold PCS</span>
            <SortButton
              row="count"
              type="0"
              :currentSortDirection="currentSortDirection"
              :currentSortRow="currentSortRow"
              v-on:sortBy="sortRow"
            />
          </td>
          <td class="right">
            <SortButton
              row="profit"
              type="0"
              :currentSortDirection="currentSortDirection"
              :currentSortRow="currentSortRow"
              v-on:sortBy="sortRow"
              floatRight="yes"
            />
            <span>Earned</span>
          </td>
        </thead>

        <tr v-for="product in sortedData" :key="product.id">
          <td class="important">
            <span>{{ product.turn }}.</span>
          </td>
          <td>{{ product.productName }}</td>
          <td>{{ product.count }} pcs</td>
          <td class="right">{{ product.profit | numbersThousands }} €</td>
        </tr>
        <tr v-if="!this.sourceData.length">
          <td>{{ $t(`texts.data.no-products-sold`) }}</td>
        </tr>
      </table>

      <!-- <div
        class="tabulka__body__show-more"
      >
        <div class="tabulka__body__show-more--img"></div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SortButton from "@/components/game/table/SortButton.vue";
import sortingLogicMixin from "@/components/game/table/sortingLogicMixin.js"; // obsahuje logiku k sortovani
import JsonExcel from "vue-json-excel";

export default {
  name: "SoldProducts",
  mixins: [sortingLogicMixin],
  components: {
    SortButton,
    downloadExcel: JsonExcel,
  },
  data() {
    return {
      currentSortRow: "turn",
      currentSortDirection: -1,
      json_fields: {
        Round: "turn",
        "Product name": "productName",
        Quality: "quality",
        "Cost per unit": "costPerUnit",
        "Price per unit": "pricePerUnit",
        "Sold PCS": "count",
        Earned: {
          field: "profit",
          callback: (value) => {
            return `${value.toLocaleString()} €`;
          },
        },
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },
  props: {
    TableWidth: String,
  },
  computed: {
    ...mapGetters({
      sourceData: "teamProductsSales",
    }),
  },
  methods: {},
};
</script>
